import { useState } from "react";
import { Divider, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import SecondaryButton from "../../../common/components/button/SecondaryButton";
import PrimaryButton from "../../../common/components/button/PrimaryButton";
import CustomModal from "../../../common/components/modal/CustomDetailModal";
import { TitleAndRadio } from "../../../common/components/radio/TitleAndRadio";
import { TitleAndInput } from "../../../common/components/input/TitleAndInput";
import Translate from "../../../common/translate/Translate";
import { Theme } from "../../../common/Theme";
import { useDevice } from "../../../common/hooks/useDevice";
import LMPAuthApi from "../../../api/lmp/LMPAuthApi";
import LocalStorageKey from "../../../common/enums/LocalStorageKey";

const typeOptions = [
    { value: "Franchise Manager", label: "Manager" },
    { value: "Call Center", label: "Call Center" },
    { value: "Shop Owner", label: "Owner" },
];

const statusOptions = [
    { value: "Enable", label: Translate("marketing.quota.enable") },
    { value: "Disable", label: Translate("marketing.quota.disable") },
];

export default function RoleRequestUserInfoSubModal({ isOpen, onClose, dto, currentPage, getList }) {
    const api = new LMPAuthApi();
    console.log("dto: ", dto);
    const [type, setType] = useState(dto?.type || "Staff");
    const [id, setId] = useState(dto?.email || "");
    const [status, setStatus] = useState(dto?.quota || "Enable");
    const [name, setName] = useState(dto?.name || "-");
    const [contact, setContact] = useState(dto?.contact || "-");

    const currentDevice = useDevice();

    const handleRoleProcess = (apprFlag) => {
        api.processRole({
            accessToken: localStorage.getItem(LocalStorageKey.accessToken),
            usrNo: dto.id,
            seqNo: dto.seqNo,
            apprFlag: apprFlag === true ? "Y" : "C",
            compCnt: apprFlag === true ? "승인" : "거절",
        })
            .then(() => {
                getList(currentPage);
                onClose();
            })
            .catch((error) => {
                // LMP 게이트웨이는 비즈니스 에러를 406으로 내려주며, 실제 원인은 응답 바디 error.code에 담긴다.
                const lmpError = error?.response?.data?.error;
                console.error("processRole 실패 - status:", error?.response?.status, "error:", lmpError ?? error);
                onClose();
            });
    };

    return (
        <CustomModal
            title={"User Detail"}
            isOpen={isOpen}
            onClose={onClose}
            width={currentDevice === "mobile" || currentDevice === "tablet" ? "60vw" : "552px"}
            side={currentDevice === "mobile" || currentDevice === "tablet" ? "center" : "right"}
            paddingRight={currentDevice === "mobile" || currentDevice === "tablet" ? "0" : "910px"}
            overlayColor={currentDevice === "mobile" || currentDevice === "tablet" ? undefined : "transparent"}
            height={"auto"}
            alignItems={"flex-start"}
            paddingTop={"5vh"}
            bottomButtons={
                dto.apprvFlag === "N" ? (
                    <Row justifyContent={"flex-end"} width={"100%"} padding={"22px 20px"}>
                        <SecondaryButton
                            text={"Reject"}
                            width={"90px"}
                            padding={"7.75px 14.5px"}
                            onClick={() => handleRoleProcess(false)}
                            icon={"close_red"}
                            fontColor={Theme.color.rose500}
                        />
                        <SizedBox width={"10px"} />
                        <PrimaryButton
                            text={"Approve"}
                            width={"90px"}
                            padding={"9.75px 14.5px"}
                            onClick={() => handleRoleProcess(true)}
                        />
                    </Row>
                ) : (
                    <></>
                )
            }
        >
            <SizedBox
                width={"100%"}
                height={"auto"}
                border={"solid 1px #E6E6E9"}
                borderRadius={"16px"}
                alignItem={"flex-start"}
                justifyContent={"flex-start"}
                padding={"22px 20px"}
            >
                <TitleAndRadio
                    title={"Type"}
                    options={typeOptions}
                    selectedOption={type}
                    setSelectedOption={setType}
                    // isEditMode={true}
                />
                <Divider marginTop={"23px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={"ID"}
                    type={"normal"}
                    placeholder={""}
                    inputValue={id}
                    setInputValue={setId}
                    disabled={true}
                />
                <Divider marginTop={"11px"} marginBottom={"23px"} lineStyle={"custom-dotted"} />
                <TitleAndRadio
                    title={"Status"}
                    options={statusOptions}
                    selectedOption={status}
                    setSelectedOption={setStatus}
                    isEditMode={true}
                />
                <Divider marginTop={"23px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={"name"}
                    type={"normal"}
                    placeholder={""}
                    inputValue={name}
                    setInputValue={setName}
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={"Contact"}
                    type={"normal"}
                    placeholder={""}
                    inputValue={contact}
                    setInputValue={setContact}
                />
            </SizedBox>
        </CustomModal>
    );
}
